'use strict';

var badge = {};

exports.__exports = badge;
//# sourceMappingURL=badge.cjs.map
